import React, { useState } from 'react';

import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import SpinnerBlock from '../../../common/SpinnerBlock';
import moment from 'moment';
import {
  PHYSICAL_SET_ORDER_ACTION_TYPES,
  PHYSICAL_SET_STATUS_TRANSLATE,
  PHYSICAL_SET_STATUS_STYLES,
} from '../../../../config';
import StatusBadge from '../../../common/StatusBadge';
import Pagination from '../../../common/Pagination';
import { useAutoTranslation } from '../../../../helpers/useAutoTranslation';

const SetsCardWrapper = styled('div')`
  margin: 0 -22px;
  padding-top: 15px;

  .form-inline {
    padding: 0 15px;

    input {
      border: 1px solid #e3e5e7;
    }
  }

  .new-order {
    position: fixed;
    right: 6%;
    bottom: 4%;
    z-index: 1;
    width: 70px;
    height: 70px;
    border-radius: 50%;
    font-size: 24px;
    display: flex;
    align-items: center;
    justify-content: center;

    span {
      display: none;
    }
  }
`;

const Wrapper = styled('div')`
  margin: 0 -7px;
  .title {
    font-weight: 500;
    color: #343a40;
  }
  .shortname-td {
    color: #343a40;
    font-weight: bold;
    max-width: 300px;

    .ids-span {
      font-size: 11px;
      color: #98a6ad;
      cursor: pointer;
      font-weight: normal;
    }
  }
  .order-card {
    background: white;
    border: 1px solid #e3e5e7;
    border-radius: 5px;
    margin-top: 15px;
    padding: 10px 15px;
    position: relative;
    font-size: 11px;
    display: flex;
    justify-content: space-between;
  }
  .order-col-1 {
    flex: 0 0 90%;
  }
  .fe-copy,
  .fe-trash-2 {
    font-size: 16px;
  }
  .order-col-2 {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
`;

const MobileComponent = ({
  tableData,
  search,
  loading,
  total,
  handleSearch,
  handleCopyItem,
  handleRemoveItem,
  handleChangePage,
}) => {
  const [page, setPage] = useState(0);

  const handlePageSelect = (pageIndex) => {
    setPage(pageIndex);
    handleChangePage(pageIndex);
  };

  const { t } = useAutoTranslation();

  return (
    <>
      <SetsCardWrapper>
        <form className="form-inline">
          <input
            type="text"
            className="form-control"
            id="ordersSearch"
            placeholder={t('Поиск')}
            value={search}
            onChange={handleSearch}
          />
          <Link
            to="/physical-set-order"
            type="button"
            className="btn btn-danger waves-effect waves-light new-order"
          >
            <i className="fe-plus" />
          </Link>
        </form>
      </SetsCardWrapper>

      <Wrapper>
        {loading ? <SpinnerBlock show={loading} /> : null}

        {tableData
          ? tableData.map((o, i) => (
              <div className="order-card">
                <div className="order-col-1">
                  <StatusBadge
                    status={o.status}
                    translateData={PHYSICAL_SET_STATUS_TRANSLATE}
                    stylesData={PHYSICAL_SET_STATUS_STYLES}
                  />
                  <div className="mt-1">
                    <div>{`Задание ${o.id} от ${moment(o.createTs).format(
                      'DD.MM.YYYY HH:mm',
                    )}`}</div>
                    <div className="text-muted">{o?.externalId}</div>
                    <div>
                      {PHYSICAL_SET_ORDER_ACTION_TYPES.find((t) => t.value === o.action)?.label}
                    </div>
                  </div>
                  <div className="mt-1">
                    <span className="text-muted">{t('Комплект')} - </span>
                    <span className="title">
                      {o.physicalSet?.shortName} {o.physicalSet?.id}
                      {o.physicalSet?.extId ?? null}
                    </span>
                  </div>
                  <div>
                    {t('Количество')}: {o.quantity} {t('шт')}
                  </div>
                </div>
                <div className="order-col-2">
                  <div className="item-remove mb-2 mt-2" onClick={() => handleCopyItem(o)}>
                    <i className="fe-copy" />
                  </div>
                  <div className="item-remove" onClick={() => handleRemoveItem(o)}>
                    <i className="fe-trash-2" />
                  </div>
                </div>
              </div>
            ))
          : null}
        {tableData && (
          <Pagination
            total={total}
            currentPage={Number(page)}
            perPage={10}
            onPageSelect={handlePageSelect}
          />
        )}
      </Wrapper>
    </>
  );
};

export default MobileComponent;
